import {theme as base} from '@chakra-ui/react'
import {FontTheme} from '../types/typography.types'

const fonts: FontTheme = {
    fonts: {
        heading: `'Montserrat', 'Noto Sans', ${base.fonts?.heading}`,
        body: `'Montserrat', 'Noto Sans', ${base.fonts?.body}`,
        primary: `'Montserrat', 'Noto Sans', ${base.fonts?.heading}`,
        secondary: `'Montserrat', 'Noto Sans', ${base.fonts?.body}`,
    },
}

export default fonts
